/** Normalized from onboarding / API `personalDetails.gender` values. */
export type LetterGenderTone = "male" | "female" | "neutral";

export function parseLetterGender(gender?: string | null): LetterGenderTone {
  const raw = (gender ?? "").trim().toLowerCase();
  if (!raw) return "neutral";
  if (/\bfemale\b|\bwoman\b|\bgirl\b|^f$/i.test(raw)) return "female";
  if (/\bmale\b|\bman\b|\bboy\b|^m$/i.test(raw)) return "male";
  return "neutral";
}

/** Pronouns and honorifics for letter copy. */
export function letterGenderPhrases(tone: LetterGenderTone) {
  const possessiveCap = tone === "female" ? "Her" : tone === "male" ? "His" : "His/Her";
  const possessiveLower = tone === "female" ? "her" : tone === "male" ? "his" : "his/her";
  const subjectLower = tone === "female" ? "she" : tone === "male" ? "he" : "he/she";
  const objectLower = tone === "female" ? "her" : tone === "male" ? "him" : "him/her";
  const honorific = tone === "female" ? "Ms." : tone === "male" ? "Mr." : null;
  return { possessiveCap, possessiveLower, subjectLower, objectLower, honorific };
}
